import React from "react";
import { motion } from "framer-motion";
import { ABOUT } from "../lib/site";
import { useSite } from "../context/SiteContext";

export const About = () => {
  const site = useSite();
  const title = site?.content?.about_title || ABOUT.title;
  const paragraphs =
    site?.content?.about_paragraphs?.length ? site.content.about_paragraphs : ABOUT.paragraphs;
  const [titleHead, ...titleRest] = title.split(":");

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 lg:py-40 relative">
      <div className="max-w-[900px] mx-auto px-6 md:px-12">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gold block"
        >
          À propos
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.05 }}
          className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-tight"
        >
          {titleRest.length ? (
            <>
              {titleHead}: <span className="gold-text italic">{titleRest.join(":")}</span>
            </>
          ) : (
            <span className="gold-text italic">{titleHead}</span>
          )}
        </motion.h2>

        <div className="mt-8 space-y-5">
          {paragraphs.map((p, i) => (
            <motion.p
              key={p.slice(0, 32)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="text-base lg:text-lg font-light text-[#B8B8B8] leading-relaxed text-hover"
            >
              {p}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
};

